import React, { useState, useEffect } from "react";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import backgroundImage from "../assets/HomePage.jpg";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [Credienticals, setCredienticals] = useState({});
  const navigate = useNavigate();

  const validateLogin = async (event) => {
    event.preventDefault();
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/auth.php`;

    try {
      const formData = new FormData();
      formData.append("userid", username);
      formData.append("password", password);

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      setCredienticals(data);
      if (data.message === "Login successful") {
        const userDetails = {
          username: data.user_name,
          role: data.role,
          id: data.user_id,
          state: data.state,
          client_name: data.client_name,
        };
        localStorage.setItem("userdetails", JSON.stringify(userDetails));
        navigate("/layamA");
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error("Error during login:", error);
    }
  };

  const handleforgot = () => {
    navigate("/Forgot");
  };

  useEffect(() => {
    console.log(Credienticals);
  }, [Credienticals]);

  return (
    <div
      className="login-page"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      {/* <div className="login-container">
        <div className="login-box">
          <form onSubmit={validateLogin}>
            <h2 className="loginh2">Login</h2>
            <div className="input-box">
              <input 
                value={username} 
                onChange={(e) => setUsername(e.target.value)} 
                required 
              />
              <label>User Name</label>
            </div>
            <div className="input-box">
              <input 
                type="password" 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
                required 
              />
              <label>Password</label>
            </div>
            <button className="loginbutton">Login</button>
          </form>
        </div>
      </div> */}

      <div class="container1">
        <div class="cards">
          <div class="card card-1">
            <div class="card__content">
              <div class="login-box">
                <form onSubmit={validateLogin}>
                  <h2 className="loginh2">Login</h2>
                  <div class="input-box">
                    <span class="icon">
                      <ion-icon name="mail"></ion-icon>
                    </span>
                    {/* <input type="email" required/> */}
                    <input
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      required
                    />
                    <label>User Name</label>
                  </div>

                  <div class="input-box">
                    <span class="icon">
                      <ion-icon name="lock-closed"></ion-icon>
                    </span>

                    <input
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <label>Password</label>
                  </div>

                  <div class="remember-forgot">
                    <label> </label>
                    {/* <a href="#">Forgot Password?</a> */}
                    <span onClick={handleforgot}>Forgot Password?</span>
                  </div>

                  <button className="loginbutton">Sign In</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;